export default __webpack_public_path__ + "assets/a57dbd795d218262d061fcd50a0a4b69.png";